import { render, staticRenderFns } from "./RequestsDetailPopup.vue?vue&type=template&id=ac375408&"
import script from "./RequestsDetailPopup.vue?vue&type=script&lang=js&"
export * from "./RequestsDetailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports